<div class="w-full create-activity-one cst-content-ctnr">
  <div
    class="w-full p-8 bg-zinc-100 dark:bg-gray-800 flex-col justify-start items-start gap-2.5 inline-flex"
  >
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    <div
      class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex"
    >
      <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
        <div
          class="w-full grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex"
        >
          <div
            class="w-full titre self-stretch text-gray-900 text-4xl font-semibold leading-[38px]"
          >
            Ajouter un nouveau certificat mentorat
          </div>

          <div
            class="bg-green-500 border border-400 text-white-700 px-4 py-3 rounded relative"
            role="alert"
            *ngIf="valid"
          >
            <span class="block sm:inline"> Certificat ajouté avec succès </span>
          </div>

          <div
            class="float-right bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative"
            role="alert"
            *ngIf="error"
          >
            <span class="block sm:inline"
              >Erreur lors de l'ajout du certificat
            </span>
          </div>
          <div
            class="bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative"
            role="alert"
            *ngIf="inValid"
          >
            <span class="block sm:inline"
              >Merci de remplir tous les champs
            </span>
          </div>
          <form
            class="w-full grow shrink"
            [formGroup]="mentoratCertificateForm"
          >
            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="name"
                  >Nom Certificat
                </label>
                <input
                  [style.border]="
                    inValidName == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="name"
                  id="name"
                  type="text"
                  placeholder="Nom Certificat"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="fullname"
                  >Nom Complet</label
                >
                <input
                  [style.border]="
                    invalidFullname == true ? '1px solid #EB4045' : ''
                  "
                  type="text"
                  formControlName="fullname"
                  id="fullname"
                  placeholder="Nom Complet du certificat"
                  class="w-full no-resize mb-1 pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>

              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="fullname"
                  >Nom abrégé</label
                >
                <input
                  [style.border]="
                    invalidFullname == true ? '1px solid #EB4045' : ''
                  "
                  type="text"
                  formControlName="shortname"
                  id="shortname"
                  placeholder="Nom abrégé"
                  class="w-full no-resize mb-1 pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="certificateCode"
                  >Code du Certificat</label
                >
                <input
                  [style.border]="
                    invalidCertificateCode == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="certificateCode"
                  id="certificateCode"
                  type="text"
                  placeholder="Code du certificat"
                  class="w-full no-resize mb-1 pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="plateforme"
                  >Plateforme</label
                >
                <select
                  [style.border]="
                    invalidPlatforme == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="plateforme"
                  id="plateforme"
                  class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
                >
                  <option value="" disabled>
                    <p class="text-gray-50">Choisissez la plateforme LMS</p>
                  </option>
                  <option *ngFor="let platform of platforms" [value]="platform">
                    {{ platform }}
                  </option>
                </select>
              </div>
            </div>

            <div class="py-3 rounded-xl gap-4">
              <label
                class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full pt-4"
                for="description"
                >Description du certificat</label
              >
              <textarea
                [style.border]="
                  invalidDescription == true ? '1px solid #EB4045' : ''
                "
                formControlName="description"
                id="description"
                placeholder="Description du  certificat"
                class="w-full no-resize mb-1 pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                maxlength="300"
              ></textarea>
              <div
                class="indications mb-1 pr-db font-medium inter-medium f12 color-gray-300 w-full text-xs"
              >
                300 caractères autorisés
              </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full flex pt-2 justify-end items-end gap-2">
                <input
                  type="reset"
                  style="border-radius: 0.5rem"
                  value="Annuler"
                  (click)="resetCreation()"
                  class="text-sm w-fit text-white mat-mdc-input-element font-semibold self-stretch px-2.5 py-2.5 bg-red rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
                <input
                  type="submit"
                  value="Sauvegarder"
                  style="border-radius: 0.5rem"
                  (click)="createMentoratCertificate()"
                  [disabled]="valid"
                  class="text-sm w-fit text-white mat-mdc-input-element bg-blue font-semibold self-stretch px-2.5 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
